import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { companyInfo } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-container">
        {/* Footer Top */}
        <div className="footer-top">
          {/* Company Info */}
          <div className="footer-column footer-company">
            <img 
              src="https://customer-assets.emergentagent.com/job_0ccb6f97-1bfb-4ee2-9332-dc85509860bf/artifacts/liu25jwb_Savanna%20Skies%20Logo.jpeg"
              alt="Savanna Skies Logo"
              className="footer-logo"
            />
            <p className="footer-tagline">{companyInfo.tagline}</p>
            <p className="footer-description">
              African-owned aircraft leasing and financing solutions for a growing continent
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-column">
            <h3 className="footer-column-title">Quick Links</h3>
            <ul className="footer-links">
              <li><Link to="/" className="footer-link">Home</Link></li>
              <li><Link to="/about" className="footer-link">About Us</Link></li>
              <li><Link to="/services" className="footer-link">Services</Link></li>
              <li><Link to="/fleet" className="footer-link">Fleet</Link></li>
              <li><Link to="/contact" className="footer-link">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-column">
            <h3 className="footer-column-title">Our Services</h3>
            <ul className="footer-links">
              <li><Link to="/services" className="footer-link">Operating Leases</Link></li>
              <li><Link to="/services" className="footer-link">Engine Leasing</Link></li>
              <li><Link to="/services" className="footer-link">Portfolio Management</Link></li>
              <li><Link to="/services" className="footer-link">Financing Solutions</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-column">
            <h3 className="footer-column-title">Contact Us</h3>
            <ul className="footer-contact-list">
              <li className="footer-contact-item">
                <Mail size={18} className="footer-contact-icon" />
                <span>{companyInfo.email}</span>
              </li>
              <li className="footer-contact-item">
                <Phone size={18} className="footer-contact-icon" />
                <span>{companyInfo.phone}</span>
              </li>
              <li className="footer-contact-item">
                <MapPin size={18} className="footer-contact-icon" />
                <span>{companyInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="footer-copyright">
              © {currentYear} {companyInfo.name}. All rights reserved.
            </p>
            <div className="footer-legal">
              <a href="#" className="footer-legal-link">Privacy Policy</a>
              <span className="footer-legal-separator">|</span>
              <a href="#" className="footer-legal-link">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;